<template>
    <div class="nurse-dashboard-middle">
        <vs-row vs-type="flex">
            <PatientCountWidget 
                :patientCountData="patientCountData"
                :loadingChart="loadingCharts.patientCount"
                :isFetchingMainFilters="isFetchingMainFilters"
            />
        </vs-row>

        <vs-row vs-type="flex">
            <div :style="{width: '100%'}">
                <FeedbackWidget slug="insights-nurse-dashboard-feedback" :clinicId="selectedClinic"/>
            </div>
        </vs-row>
        
        <vs-row vs-type="grid" class="mix-grids">
            <TreatmentMixWidget 
                widgetTitle="Treatment Mix"
                :selectedNurseName="selectedNurseName"
                :treatmentMixYourClinicData="treatmentMixYourClinicData"
                :loadingChart="loadingCharts.treatmentMix"
                :isFetchingMainFilters="isFetchingMainFilters"
            />
            
            <div class="widget-container chart-widget" :style="{justifyContent: 'flex-start', width: '100%', minHeight: '280px', paddingBottom: '10px'}">
                <vs-row vs-justify="space-between" style="margin-bottom: 15px;">
                    <div class="widget-title" :style="{display: 'flex', width: '100%', justifyContent: 'space-between'}">Average Appointments Per Day ({{selectedNurseName ? selectedNurseName : "Your Clinic" }} vs. High Volume Nurses)
                    
                        <QuestionTooltip>
                            <template slot="header">Average Appointments Per Day ({{selectedNurseName ? selectedNurseName : "Your Clinic" }} vs. High Volume Nurses)</template>
                            <template slot="body">Average number of Appointments tracked in the X per day</template>
                        </QuestionTooltip>
                    </div>
                    <div class="widget-options flex" style="justify-content: flex-end;">
                    </div>
                </vs-row>
                <div class="widget-chart avgAppointmentData" style="position: relative; width: 100%; height: 100%;">
                    <div 
                        class="skeleton skeleton-chart-columns" 
                        style="
                            --cols: 10;
                            --col-w: 30px;
                            --col-gap: 20px;
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            margin: 0 auto;
                        "
                        v-if="loadingCharts.avgAppointmentData || isFetchingMainFilters"
                    ></div>
                    <template v-else>
                        <BarChart 
                            v-if="avgAppointmentData.datasets.length"
                            :height="230"
                            :width="250"
                            :chartData="avgAppointmentData"
                            :chartOptions="avgAppointmentsDataOptions"
                        />
                        <div v-else class="no-data-available">No Data Available</div>
                    </template>
                </div>
            </div>
        </vs-row>

        <vs-row vs-type="flex">
            <div class="widget-container chart-widget" :style="{width: '100%', minHeight: '330px', justifyContent: 'flex-start'}">
                <vs-row vs-justify="space-between">
                    <div class="widget-title" :style="{display: 'flex', width: '100%', justifyContent: 'space-between'}">Product Dosage Trends
                    
                        <QuestionTooltip>
                            <template slot="header">Product Dosage Trends</template>
                            <template slot="body">
                                Number of treatments that you have completed broken down by area for a specific product, and average volume of product and average volume of product used per treatment compared with Fresh Clinics High Volume Clinics.
                                <br>Filler volumes displayed in ml, Toxin volumes displayed in units 
                            </template>
                        </QuestionTooltip>
                    </div>
                </vs-row>
                <vs-row vs-type="flex" class="insight-table-header">
                    <div class="dashboard-select full-label" style="width: 250px;">
                        <label class="select-label" style="width: 55px;">Product</label>
                        <el-select 
                            popper-class="popper-select" 
                            v-model="selectedProduct"
                            placeholder=""
                            :disabled="loadingCharts.productDosageTrends || isFetchingMainFilters">
                            <el-option :key="index" :value="item.value" :label="item.text" v-for="item,index in productList" />
                        </el-select>
                    </div>
                </vs-row>
                <div style="position: relative; width: 100%; height: 100%;">
                    <div 
                        class="skeleton skeleton-line" 
                        style="
                            --lines: 5;
                            --l-gap: 20px;
                            --c-w: 100%;
                            position: absolute;
                            left: 0;
                            right: 0;
                            margin: 0 auto;
                        "
                        v-if="loadingCharts.productDosageTrends || isFetchingMainFilters"
                    ></div>
                    <template v-else>
                        <vs-table v-if="areas.length" noDataText="" class="insight-table-body" :data="areas" style="position: relative;  width: 100%; height: 100%;">
                            <template slot="thead">
                                <vs-th>Area</vs-th>
                                <vs-th></vs-th>
                                <vs-th class="th-wrapper" colspan="2">
                                    <vs-row vs-justify="center" class="pb-1">Total Treatments</vs-row>
                                    <vs-row>
                                        <div class="col2">Amount</div>
                                        <div class="col2">% of Total</div>
                                    </vs-row>
                                </vs-th>
                                <vs-th></vs-th>
                                <vs-th class="th-wrapper" colspan="4">
                                    <vs-row vs-justify="center" class="pb-1">Avg Treatment Volume</vs-row>
                                    <vs-row>
                                        
                                        <div class="subheading col2">
                                            <div class="subvalue col2">You: Average</div>
                                            <div class="subvalue col2">You: Upper Range</div>
                                        </div>
                                        <div class="subheading col2">
                                            <div class="subvalue col2">High Volume Clinic: Average</div>
                                            <div class="subvalue col2">High Volume Clinic: Upper Range</div>
                                        </div>
                                    </vs-row>
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                    <vs-td :data="data[indextr].area">
                                        {{data[indextr].area}}
                                    </vs-td>

                                    <vs-td></vs-td>

                                    <vs-td colspan="2" class="td-span text-center">
                                        <vs-row>
                                            <div class="col2">{{data[indextr].totalTreatmentsAmount}}</div>
                                            <div class="col2">{{data[indextr].totalTreatmentsPercentage}}%</div>
                                        </vs-row>
                                    </vs-td>

                                    <vs-td></vs-td>

                                    <vs-td colspan="4" class="td-span text-center">
                                        <vs-row>
                                            <div class="subheading col2">
                                                <div class="subvalue col2">{{data[indextr].clinicMinAmount}}</div>
                                                <div class="subvalue col2">{{data[indextr].clinicHighAmount}}</div>
                                            </div>
                                            <div class="subheading col2">
                                                <div class="subvalue col2">{{data[indextr].hvcMinAmount}}</div>
                                                <div class="subvalue col2">{{data[indextr].hvcMaxAmount}}</div>
                                            </div>
                                        </vs-row>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                        <div v-else class="no-data-available">No Data Available</div>
                    </template>
                </div>
            </div>
        </vs-row>

        <vs-row vs-type="grid" class="grids-2">
            <div class="widget-container chart-widget" vs-justify="center" :style="{width: '100%', minWidth: '100px', minHeight: '320px'}">
                <vs-row vs-justify="space-between">
                    <div class="widget-title" :style="{display: 'flex', width: '100%', justifyContent: 'space-between'}">Patient Demographics
                    
                        <QuestionTooltip>
                            <template slot="header">Patient Demographics</template>
                            <template slot="body">Demographic breakdown of your treated patients by age and gender</template>
                        </QuestionTooltip>
                    </div>
                </vs-row>
                <div class="widget-chart" style="position: relative;  width: 100%; height: 100%;">
                    <vs-row vs-type="flex" vs-justify="end" class="insight-table-header">
                        <div class="dashboard-select full-label" style="width: 200px;">
                            <label class="select-label">Time Period</label>
                            <el-select 
                                popper-class="popper-select" 
                                v-model="selectedPatientTimePeriod"
                                :disabled="loadingCharts.patientDemographics || isFetchingMainFilters">
                                <el-option :key="item.value" :value="item.value" :label="item.text" v-for="item in timePeriodList" />
                            </el-select>
                        </div>
                    </vs-row>
                    
                    <div 
                        class="skeleton skeleton-line" 
                        style="
                            --lines: 4;
                            --l-gap: 20px;
                            --c-w: 100%;
                            position: absolute;
                            top: 80x;
                            left: 0;
                            right: 0;
                            margin: 0 auto;
                        "
                        v-if="loadingCharts.patientDemographics || isFetchingMainFilters"
                    ></div>
                    <template v-else>
                        <vs-table v-if="patientDemographics.length" class="insight-table-body center-table" :data="patientDemographics">
                            <template slot="thead">
                                <vs-th>Age</vs-th>
                                <vs-th>Female</vs-th>
                                <vs-th>Male</vs-th>
                                <vs-th class="th-wrapper" colspan="2">
                                    <vs-row vs-justify="center">Total</vs-row>
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                    <vs-td :data="data[indextr].age">
                                        {{data[indextr].age}}
                                    </vs-td>

                                    <vs-td class="text-center" :data="data[indextr].female">
                                        {{Math.trunc(data[indextr].female)}}%
                                    </vs-td>
                                    <vs-td class="text-center" :data="data[indextr].male">
                                        {{Math.trunc(data[indextr].male)}}%
                                    </vs-td>

                                    <vs-td class="text-center divider-left" :data="data[indextr].totalCount">
                                        {{data[indextr].totalCount}}
                                    </vs-td>
                                    <vs-td class="text-center" :data="data[indextr].totalPercentage">
                                        {{Math.trunc(data[indextr].totalPercentage)}}%
                                    </vs-td>
                                </vs-tr>
                                
                                <vs-tr class="total-row" key="patient-total-row">
                                    <vs-td :data="patientTotal.age">
                                        {{patientTotal.age}}
                                    </vs-td>

                                    <vs-td class="text-center" :data="patientTotal.female">
                                        {{Math.trunc(patientTotal.female)}}%
                                    </vs-td>
                                    <vs-td class="text-center" :data="patientTotal.male">
                                        {{Math.trunc(patientTotal.male)}}%
                                    </vs-td>

                                    <vs-td class="text-center divider-left" :data="patientTotal.totalCount">
                                        {{patientTotal.totalCount}}
                                    </vs-td>
                                    <vs-td class="text-center" :data="patientTotal.totalPercentage">
                                        {{patientTotal.totalPercentage}}%
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                        <div v-else class="no-data-available">No Data Available</div>
                </template>
                </div>
            </div>

            <div class="widget-container chart-widget" vs-justify="center" :style="{width: '100%', minWidth: '100px', minHeight: '320px'}">
                <vs-row vs-justify="space-between">
                    <div class="widget-title">Average Treatment Areas per Appointments</div>
                </vs-row>
                <div class="widget-chart" style="position: relative;  width: 100%; height: 100%;">
                    <vs-row vs-type="flex" class="insight-table-header">
                        <div class="dashboard-select full-label" style="width: 250px;">
                            <label class="select-label">Product Type</label>
                            <el-select 
                                style="width: 100%;"
                                popper-class="popper-select" 
                                v-model="selectedProductType"
                                :disabled="loadingCharts.avgTreatmentsPerAppointment || isFetchingMainFilters">
                                <el-option :key="index" :value="item.value" :label="item.text" v-for="item,index in productTypeList" />
                            </el-select>
                        </div>
                    </vs-row>
                    <vs-table class="insight-table-body center-table" :data="avgTreatmentsPerAppointment" style="position: relative;  width: 100%; height: 100%;">
                        <template slot="thead">
                            <vs-th>Age</vs-th>
                            <vs-th class="th-wrapper" colspan="2">
                                <vs-row vs-justify="center" class="pb-1">Female</vs-row>
                                <vs-row>
                                    <div class="col2">You</div>
                                    <div class="col2">High Volume Clinics</div>
                                </vs-row>
                            </vs-th>
                            <vs-th class="th-wrapper" colspan="2">
                                <vs-row vs-justify="center" class="pb-1">Male</vs-row>
                                <vs-row>
                                    <div class="col2">You</div>
                                    <div class="col2">High Volume Clinics</div>
                                </vs-row>
                            </vs-th>
                        </template>

                        <template v-if="!loadingCharts.avgTreatmentsPerAppointment && !isFetchingMainFilters" slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="data[indextr].age">
                                    {{data[indextr].age}}
                                </vs-td>

                                <vs-td class="text-center" :data="data[indextr].female">
                                    {{(data[indextr].female) ? roundToDecimalPlaces(data[indextr].female, 1) : 0}}
                                </vs-td>
                                <vs-td class="text-center" :data="data[indextr].femaleTop">
                                    {{(data[indextr].femaleTop) ? roundToDecimalPlaces(data[indextr].femaleTop, 1) : 0 }}
                                </vs-td>

                                <vs-td class="text-center" :data="data[indextr].male">
                                    {{(data[indextr].male) ? roundToDecimalPlaces(data[indextr].male, 1) : 0}}
                                </vs-td>
                                <vs-td class="text-center" :data="data[indextr].maleTop">
                                    {{(data[indextr].maleTop) ? roundToDecimalPlaces(data[indextr].maleTop, 1) : 0}}
                                </vs-td>
                            </vs-tr>
                            
                            <vs-tr class="total-row" key="treatments-total-row">
                                <vs-td :data="treatmentsTotal.age">
                                    {{treatmentsTotal.age}}
                                </vs-td>

                                <vs-td class="text-center" :data="treatmentsTotal.female">
                                    {{treatmentsTotal.female}}
                                </vs-td>
                                <vs-td class="text-center" :data="treatmentsTotal.femaleTop">
                                    {{treatmentsTotal.femaleTop}}
                                </vs-td>

                                <vs-td class="text-center" :data="treatmentsTotal.male">
                                    {{treatmentsTotal.male}}
                                </vs-td>
                                <vs-td class="text-center" :data="treatmentsTotal.maleTop">
                                    {{treatmentsTotal.maleTop}}
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <div 
                        class="skeleton skeleton-line" 
                        style="
                            --lines: 3;
                            --l-gap: 20px;
                            --c-w: 100%;
                            position: absolute;
                            top: 130px;
                            left: 0;
                            right: 0;
                            margin: 0 auto;
                        "
                        v-if="loadingCharts.avgTreatmentsPerAppointment || isFetchingMainFilters"
                    ></div>
                </div>
            </div>
        </vs-row>
    </div>
</template>
<script>
import BarChart from '../../components/insights/charts/BarChart.vue';
import { mapActions } from 'vuex';
import moment from 'moment';
import { uniqBy, sortBy, find, filter, map, meanBy } from 'lodash';
import QuestionTooltip from '../../components/insights/common/QuestionTooltip';
import PatientCountWidget from '../../components/insights/widgets/PatientCountWidget.vue';
import TreatmentMixWidget from '../../components/insights/widgets/TreatmentMixWidget.vue';
import FeedbackWidget from '../../components/insights/widgets/FeedbackWidget.vue';

export default {
    props: {
        selectedNurse: {
            type: String,
            default: '',
        },
        selectedNurseName: {
            type: String,
            default: '',
        },
        selectedClinic: {
            type: Array,
            default: () => [],
        },
        isFetchingMainFilters: {
            type: Boolean,
            default: false,
        },
        selectedDate: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        BarChart,
        QuestionTooltip,
        PatientCountWidget,
        TreatmentMixWidget,
        FeedbackWidget,
    },
    data() {
        return {
            loadingCharts: {
                productDosageTrends: false,
                treatmentMix: false,
                patientCount: false,
                avgAppointmentData: false,
                patientDemographics: false,
                avgTreatmentsPerAppointment: false,
            },
            selectedProduct: '',
            productList: [],
            areas: [],
            treatmentMixYourClinicData:{
                labels: [],
                datasets: [],
            },
            treatmentMixOptions: {
                indexAxis: 'y',
                interaction: {
                    intersect: false,
                    axis: 'y',
                },
                responsive: true,
                plugins: {
                    datalabels: {
                        opacity: 1,
                        color: function(context) {
                            return context.dataset.labelColor ? context.dataset.labelColor : '#fff';
                        },
                        display: true,
                        font: {
                            family: 'InterMedium',
                            size: 14,
                        },
                        formatter: function(value) {
                            return (value) ? Math.round(value) + '%' : '';
                        },
                    },
                    legend: {
                        pointStyleWidth	: 14,
                        boxHeight: 10,
                        display: true,
                        position: 'bottom',
                        align: 'start',
                        labels: {
                            pointStyle: 'circle',
                            usePointStyle: true,
                            padding: 20,
                            color: '#0E4333',
                            font: {
                                family: 'InterMedium',
                                size: 12,
                            },
                        },
                    },
                    title: {
                        display: true,
                        text: '',
                    },
                    tooltip: {
                        caretSize: 0,
                        caretPadding: 15,
                        backgroundColor: 'rgba(0,0,0, 0.7)',
                        titleFont: {
                            family: 'InterSemiBold',
                            size: 16,
                        },
                        bodySpacing: 3,
                        bodyFont: {
                            family: 'Inter',
                            size: 14,
                        },
                        usePointStyle: true,
                        callbacks: {
                            labelColor: function(context) {
                                return {
                                    borderColor: context.dataset.backgroundColor,
                                    backgroundColor: context.dataset.backgroundColor,
                                };
                            },
                            labelPointStyle: function() {
                                return {
                                    pointStyle: 'circle',
                                };
                            },
                            label: function(context) {
                                let label = context.dataset.label || '';

                                if (label) {
                                    label += ': ' + Math.round(context.formattedValue) + '%';
                                }
                                return label;
                            },
                        },
                        boxWidth: 10,
                        boxHeight: 10,
                        boxPadding: 8,
                        borderWidth: 0,
                        padding: 15,
                    },
                },
                scales: {
                    y: {
                        title: {
                            display: false,
                        },
                        stacked: true,
                        ticks: {
                            display: false,
                        },
                        grid: {
                            color: '#EFF1F4',
                            borderColor: '#EFF1F4',
                            tickColor: '#EFF1F4',
                            drawTicks: false,
                        },
                    },
                    x: {
                        title: {
                            display: false,
                        },
                        stacked: true,
                        ticks: {
                            color: '#0E4333',
                            font: {
                                family: 'Inter',
                                size: 12,
                            },
                            callback: function(value) {
                                return value + '%';
                            },
                        },
                        grid: {
                            color: '#EFF1F4',
                            borderColor: '#EFF1F4',
                            tickColor: '#EFF1F4',
                        },
                        min: 0,
                        max: 100,
                    },
                },   
            },
            patientTotal: {
                'age': 'Total',
                'female': 0,
                'male': 0,
                'totalCount': 0,
                'totalPercentage': 0,
            },
            patientDemographics: [],
            selectedPatientTimePeriod: 1,
            timePeriodList: [
                { value: 1, text: '1 Year' },
                { value: 2, text: '2 Years' }, 
            ],
            selectedProductType: 1,
            productTypeList: [
                { value: 1, text: 'Anti-wrinkle', param: 'toxin' },
                { value: 2, text: 'Filler', param: 'filler' }, 
            ],
            selectedTreatmentTimePeriod: 1,
            treatmentsTotal: {
                'age': 'Average',
                'female': 0,
                'femaleTop': 0,
                'male': 0,
                'maleTop': 0,
            },
            avgTreatmentsPerAppointment: [
            ],
            patientCountData: {
                'labels': [],
                'datasets': [],
            },
            avgAppointmentData: {
                'labels': [
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat',
                    'Sun',
                ],
                'datasets': [],
            },
            avgAppointmentsDataOptions: {
                interaction: {
                    intersect: false,
                        axis: 'x',
                },
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        pointStyleWidth	: 14,
                        boxHeight: 10,
                        display: true,
                        position: 'bottom',
                        align: 'start',
                        labels: {
                            pointStyle: 'circle',
                            usePointStyle: true,
                            padding: 20,
                            color: '#0E4333',
                            font: {
                                family: 'InterMedium',
                                size: 12,
                            },
                        },
                    },
                    title: {
                        display: false,
                        text: '',
                    },
                    tooltip: {
                        mode: 'index',
                        caretSize: 0,
                        caretPadding: 15,
                        backgroundColor: 'rgba(0,0,0, 0.7)',
                        titleFont: {
                            family: 'InterSemiBold',
                            size: 16,
                        },
                        bodySpacing: 3,
                        bodyFont: {
                            family: 'Inter',
                            size: 14,
                        },
                        usePointStyle: true,
                        callbacks: {
                            labelColor: function(context) {
                                return {
                                    borderColor: context.dataset.backgroundColor,
                                    backgroundColor: context.dataset.backgroundColor,
                                };
                            },
                            labelPointStyle: function() {
                                return {
                                    pointStyle: 'circle',
                                };
                            },
                            label: function(context) {
                                let label = context.dataset.label || '';

                                if (label) {
                                    label += ': ' + Math.round(context.formattedValue);
                                }
                                return label;
                            },
                        },
                        boxWidth: 10,
                        boxHeight: 10,
                        boxPadding: 8,
                        borderWidth: 0,
                        padding: 15,
                    },
                },
                scales: {
                    y: {
                        title: {
                            display: false,
                            text: '',
                        },
                        ticks: {
                            color: '#0E4333',
                            font: {
                                family: 'Inter',
                                size: 12,
                            },
                        },
                        grid: {
                            color: '#EFF1F4',
                            borderColor: '#EFF1F4',
                            tickColor: '#EFF1F4',
                        },
                    },
                    x: {
                        title: {
                            display: false,
                        },
                        grid : {
                            display : true,
                            color: '#EFF1F4',
                        },
                        ticks: {
                            color: '#0E4333',
                            font: {
                                family: 'Inter',
                                size: 12,
                            },
                        },
                    },
                },   
            },
        };
    },
    methods: {
        moment(date) {
            return moment(date);
        },
        ...mapActions('analytics', [
            'fetchClinicProductFilter',
            'fetchClinicProductDosageTrends',
            'fetchClinicTreatmentMix',
            'fetchClinicPatientCount',
            'fetchClinicPatientDemographics',
            'fetchClinicAvgAppointmentsPerDay',
            'fetchClinicAvgTreatmentsPerAppointment',
        ]),
        fetchClinicPatientCountData() {
            // Reset Chart
            this.patientCountData = {
                'labels': [],
                'datasets': [],
            };

            const payload = {
                clinic: this.selectedClinic,
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
            };
            this.loadingCharts.patientCount = true;
            this.fetchClinicPatientCount(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length)
                        this.initializePatientCountData(res.data);

                this.loadingCharts.patientCount = false;
            })
            .catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.patientCount = false;
            });
        },
        initializePatientCountData(data) {
            const monthYear = data.map(({trunc_month}) => `${this.moment(trunc_month.toString(), 'YYYY-MM-DD').format('MMM YYYY')}`);
            const newPatientsData = data.map(({first_time_patients}) => first_time_patients);
            const returningPatientsData = data.map(({returning_patients}) => returning_patients);

            
            const newPatients = newPatientsData.map((value, index) => {
                return {
                    x: returningPatientsData[index],
                    y: value,
                };
            });

            const returningPatients = newPatientsData.map((value, index) => {
                return {
                    x: value,
                    y: returningPatientsData[index],
                };
            });
            
            this.patientCountData.labels = monthYear;
            
            const hasPatientsData = newPatientsData.every(patientCount => patientCount !== null);
            const hasReturningPatientsData = returningPatientsData.every(patientCount => patientCount !== null);
            if(data && hasPatientsData && hasReturningPatientsData) {
                this.patientCountData.datasets = [
                    {
                        'label': 'New Patients',
                        'data': newPatients,
                        'backgroundColor': '#236E55',
                    },
                    {
                        'label': 'Returning Patients',
                        'data': returningPatients,
                        'backgroundColor': '#99E5DB',
                    },
                ];
            }
        },
        fetchClinicPatientDemographicsData() {
            // Reset Chart
            this.patientDemographics = [];
            
            const dateNow = this.moment().format('YYYY-MM-DD');
            const startDate = this.moment().subtract(this.selectedPatientTimePeriod, 'year').format('YYYY-MM-DD');
            const endDate = dateNow;
            const payload = {
                clinic: this.selectedClinic,
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
                start: startDate,
                end: endDate,
            };
            this.loadingCharts.patientDemographics = true;
            this.fetchClinicPatientDemographics(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length)
                        this.initializePatientDemographicsData(res.data);

                this.loadingCharts.patientDemographics = false;
            })
            .catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.patientDemographics = false;
            });
        },
        initializePatientDemographicsData(data) {
            const ageBracketsArray = uniqBy(data, 'age_bracket');
            const ageBrackets = ageBracketsArray.map(o => o.age_bracket);
            const patientDemographicsData = ageBrackets.map(ageBracket => {
                const maleData = find(data, function(o){ return o.age_bracket === ageBracket && o.gender === 'male'; });
                const femaleData = find(data, function(o){ return o.age_bracket === ageBracket && o.gender === 'female'; });
                const femalePercentdata = (femaleData) ? femaleData.percentage : 0;
                const malePercentdata = (maleData) ? maleData.percentage : 0;
                const femaleAppointmentsdata = (femaleData) ? femaleData.appointments : 0;
                const maleAppointmentsdata = (maleData) ? maleData.appointments : 0;

                return {
                    'age': ageBracket,
                    'female': this.roundToDecimalPlaces(femalePercentdata, 2),
                    'male': this.roundToDecimalPlaces(malePercentdata, 2),
                    'totalCount': (femaleData) ? this.roundToDecimalPlaces(femaleAppointmentsdata + maleAppointmentsdata, 2) : 0,
                    'totalPercentage': this.roundToDecimalPlaces(femalePercentdata + malePercentdata, 2),
                    'rawVal': {
                        'female': femalePercentdata,
                        'male': malePercentdata,
                        'totalCount': femaleAppointmentsdata + maleAppointmentsdata,
                        'totalPercentage': femalePercentdata + malePercentdata,
                    },
                };
            });
            this.patientDemographics = patientDemographicsData;

            const sumFemale = patientDemographicsData.reduce((sum, entry) => sum + entry.rawVal.female, 0);
            const sumMale = patientDemographicsData.reduce((sum, entry) => sum + entry.rawVal.male, 0);
            const sumTotalPercentage = patientDemographicsData.reduce((sum, entry) => sum + entry.rawVal.totalPercentage, 0);

            const roundedFemale = this.roundToDecimalPlaces(sumFemale, 2);
            const roundedMale = this.roundToDecimalPlaces(sumMale, 2);
            const roundedTotalPercentage = this.roundToDecimalPlaces(sumTotalPercentage, 2);

            this.patientTotal = {
                'age': 'Total',
                'female': roundedFemale,
                'male': roundedMale,
                'totalCount': patientDemographicsData.reduce((sum, entry) => sum + entry.rawVal.totalCount, 0),
                'totalPercentage': roundedTotalPercentage,
            };
        },
        roundToDecimalPlaces(num, decimalPlaces) {
            const multiplier = 10 ** decimalPlaces;
            return Math.round(num * multiplier) / multiplier;
        },
        formatCurrency(value, round) {
            let val = (value/1).toFixed(round);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        fetchClinicAvgAppointmentsPerDayData() {
            // Reset Chart
            this.avgAppointmentData.datasets = [];

            const payload = {
                clinic: this.selectedClinic,
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
                start: this.moment(this.selectedDate[0]).format('YYYY-MM-DD'),
                end: this.moment(this.selectedDate[1]).format('YYYY-MM-DD'),
            };
            this.loadingCharts.avgAppointmentData = true;
            this.fetchClinicAvgAppointmentsPerDay(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length)
                        this.initializeAvgAppointmentsPerDayData(res.data);

                this.loadingCharts.avgAppointmentData = false;
            })
            .catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.avgAppointmentData = false;
            });
        },
        initializeAvgAppointmentsPerDayData(data) {
            const dayIndex = {
                'Monday': 1,
                'Tuesday': 2,
                'Wednesday': 3,
                'Thursday': 4,
                'Friday': 5,
                'Saturday': 6,
                'Sunday': 7,
            };

            data.sort((a, b) => {
                return dayIndex[a.day_name] - dayIndex[b.day_name];
            });
            
            // get all selected clinic data
            let selectedClinicData = filter(data, function(o){ return o.clinic_type === 'Your Clinic'; });
            const topClinicData = filter(data, function(o){ return o.clinic_type === 'Top 100 Clinics'; });

            if(topClinicData.length > selectedClinicData.length){
                selectedClinicData = map(topClinicData, function(o) {
                    const val = find(selectedClinicData, function(selectedData) { return o.day_name == selectedData.day_name; });
                    return (val) ? val : {
                        avg_daily_appointments: 0,
                        clinic_type: 'Top 100 Clinics',
                        day_name: o.day_name,
                    };
                });
                
                selectedClinicData.sort((a, b) => {
                    return dayIndex[a.day_name] - dayIndex[b.day_name];
                });
            }


            const appointmentX = selectedClinicData.map(({avg_daily_appointments}) => avg_daily_appointments);
            const appointmentY = topClinicData.map(({avg_daily_appointments}) => avg_daily_appointments);

            const selectedClinicDataAppointments = appointmentX.map((value, index) => {
                return {
                    x: appointmentY[index],
                    y: value,
                };
            });

            const topClinicDataAppointments = appointmentX.map((value, index) => {
                return {
                    x: value,
                    y: appointmentY[index],
                };
            });

            this.avgAppointmentData.datasets = [{
                'label': this.selectedNurseName ? this.selectedNurseName : 'Your Clinic',
                'data': selectedClinicDataAppointments,
                'backgroundColor': '#236E55',
            },{
                'label': 'High Volume Nurses',
                'data': topClinicDataAppointments,
                'backgroundColor': '#99E5DB',
            }];
        },
        fetchClinicAvgTreatmentsPerAppointmentData() {
            const selectedProductType = find(this.productTypeList, { value: this.selectedProductType });
            const dateNow = this.moment().format('YYYY-MM-DD');
            const startDate = this.moment().subtract(this.selectedTreatmentTimePeriod, 'year').format('YYYY-MM-DD');
            const endDate = dateNow;
            const payload = {
                clinic: this.selectedClinic,
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
                treatment_type: selectedProductType.param,
                start: startDate,
                end: endDate,
            };

            this.loadingCharts.avgTreatmentsPerAppointment = true;
            this.fetchClinicAvgTreatmentsPerAppointment(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length)
                        this.initializeAvgTreatmentsPerAppointmentData(res.data);

                this.loadingCharts.avgTreatmentsPerAppointment = false;
            })
            .catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.avgTreatmentsPerAppointment = false;
            });
        },
        initializeAvgTreatmentsPerAppointmentData(data) {
            const ageBracketsArray = uniqBy(data, 'age_bracket');
            const sortedAgeBrackets = sortBy(ageBracketsArray, ({age_bracket}) => age_bracket === '18 below' ? 0 : 1);
            const ageBrackets = sortedAgeBrackets.map(o => o.age_bracket);

            const avgTreatmentsPerAppointmentData = ageBrackets.map(ageBracket => {
                const femaleData = find(data, function(o){ return o.age_bracket === ageBracket && o.gender === 'female' && o.clinic_type === 'Your Clinic'; });
                const femaleTopData = find(data, function(o){ return o.age_bracket === ageBracket && o.gender === 'female' && o.clinic_type !== 'Your Clinic'; });
                const maleData = find(data, function(o){ return o.age_bracket === ageBracket && o.gender === 'male' && o.clinic_type === 'Your Clinic'; });
                const maleTopData = find(data, function(o){ return o.age_bracket === ageBracket && o.gender === 'male' && o.clinic_type !== 'Your Clinic'; });

                return {
                    'age': ageBracket,
                    'female': (femaleData) ? femaleData.treatment_count : 0,
                    'femaleTop': (femaleTopData) ? femaleTopData.treatment_count : 0,
                    'male': (maleData) ? maleData.treatment_count : 0,
                    'maleTop': (maleTopData) ? maleTopData.treatment_count : 0,
                };
            });
            this.avgTreatmentsPerAppointment = avgTreatmentsPerAppointmentData;
            
            this.treatmentsTotal = {
                'age': 'Average',
                'female': this.roundToDecimalPlaces(meanBy(avgTreatmentsPerAppointmentData, function(o) { return o.female; }).toFixed(2), 1),
                'femaleTop': this.roundToDecimalPlaces(meanBy(avgTreatmentsPerAppointmentData, function(o) { return o.femaleTop; }).toFixed(2), 1),
                'male': this.roundToDecimalPlaces(meanBy(avgTreatmentsPerAppointmentData, function(o) { return o.male; }).toFixed(2), 1),
                'maleTop': this.roundToDecimalPlaces(meanBy(avgTreatmentsPerAppointmentData, function(o) { return o.maleTop; }).toFixed(2), 1),
            };
        },
        fetchClinicTreatmentMixData(){
            // Reset Chart
            this.treatmentMixYourClinicData = {
                labels: [],
                datasets: [],
            };

            const payload = {
                clinic: this.selectedClinic,
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
                start: this.moment(this.selectedDate[0]).format('YYYY-MM-DD'),
                end: this.moment(this.selectedDate[1]).format('YYYY-MM-DD'),
            };
            this.loadingCharts.treatmentMix = true;
            this.fetchClinicTreatmentMix(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length) {
                        // const defaultTreatmentVal = {

                        let selectedClinicTreatmentMix = res.data;

                        const toxinOnlyData = find(selectedClinicTreatmentMix, function(o){ return o.category === 'Toxin Only' && o.percentage > 0; });
                        const fillerOnlyData = find(selectedClinicTreatmentMix, function(o){ return o.category === 'Filler Only' && o.percentage > 0; });
                        const bothData = find(selectedClinicTreatmentMix, function(o){ return o.category === 'Both' && o.percentage > 0; });
                        const otherData = find(selectedClinicTreatmentMix, function(o){ return o.category === 'Others' && o.percentage > 0; });

                        
                        const treatmentMixLabel = 'Treatment Mix';
                        this.treatmentMixYourClinicData.labels = [treatmentMixLabel];
                        if(toxinOnlyData ||  fillerOnlyData || bothData) {
                            this.treatmentMixYourClinicData.datasets = [
                                {
                                    type: 'bar',
                                    label: 'Anti-Wrinkle',
                                    data: [toxinOnlyData ? toxinOnlyData.percentage : 0],
                                    backgroundColor: '#236E55',
                                    labelColor: '#fff',
                                },
                                {
                                    type: 'bar',
                                    label: 'Filler',
                                    data: [fillerOnlyData ? fillerOnlyData.percentage : 0],
                                    backgroundColor: '#99E5DB',
                                    labelColor: '#000',
                                },
                                {
                                    type: 'bar',
                                    label: 'Anti-wrinkle + Filler',
                                    data: [bothData ? bothData.percentage : 0],
                                    backgroundColor: '#5EAA98',
                                    labelColor: '#fff',
                                },
                                {
                                    type: 'bar',
                                    label: 'Other Injectables',
                                    data: [otherData ? otherData.percentage : 0],
                                    backgroundColor: '#D6D6D6',
                                    labelColor: '#000',
                                },
                            ];
                        } else {
                            // this is to hide chart if there's no data
                            this.treatmentMixYourClinicData = {
                                labels: [],
                                datasets: [],
                            };
                        }
                    }

                this.loadingCharts.treatmentMix = false;
            })
            .catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.treatmentMix = false;
            });
            
        },
        fetchClinicFilterData() {
            const payload = {
                clinic: this.selectedClinic,
                start: this.moment(this.selectedDate[0]).format('YYYY-MM-DD'),
                end: this.moment(this.selectedDate[1]).format('YYYY-MM-DD'),
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
            };
            this.loadingCharts.productDosageTrends = true;
            this.fetchClinicProductFilter(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length)
                        this.initializeProductFilterData(res.data);
            }).catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.productDosageTrends = false;
            });
        },
        initializeProductFilterData(data){
            let productList = [];
            
            const sortedProductData= sortBy(data, [function(d) { return d.name; }]);

            sortedProductData.map((d) => {
                productList.push({
                    value: d.id,
                    text: d.name,
                });
            });
            
            this.productList = productList;
            if (this.productList.length > 0) {
                this.selectedProduct = productList[0].value;
            }
        },
        fetchClinicProductDosageTrendsData() {
            // Reset Chart
            this.areas = [];

            const payload = {
                clinic: this.selectedClinic,
                start: this.moment(this.selectedDate[0]).format('YYYY-MM-DD'),
                end: this.moment(this.selectedDate[1]).format('YYYY-MM-DD'),
                product: [this.selectedProduct],
                nurse: this.selectedNurse ? [this.selectedNurse] : [],
            };

            this.loadingCharts.productDosageTrends = true;
            this.fetchClinicProductDosageTrends(payload).then((res) => {
                if(res && res.data)
                    if(res.data.length)
                        this.initializeProductDosageTrendsData(res.data);
                this.loadingCharts.productDosageTrends = false;
            })
            .catch((err) => {
                console.error('##ERROR: ', err.message);
                this.loadingCharts.productDosageTrends = false;
            });
        },
        initializeProductDosageTrendsData(data) {
            
            const areaData = data.map((d) => {
                const roundCount = d.treatment_type == 'Toxin' ? 0 : 1;
                return {
                    area: d.treatment_area,
                    totalTreatmentsAmount: d.treatment_count,
                    totalTreatmentsPercentage: this.roundToDecimalPlaces(d.treatment_count_percentage, 2),
                    clinicMinAmount: (d.clinic_min_amount) ? this.formatCurrency(d.clinic_min_amount, roundCount) : 0,
                    clinicHighAmount: (d.clinic_high_amount) ? this.formatCurrency(d.clinic_high_amount, roundCount) : 0,
                    hvcMinAmount: (d.hvc_min_amount) ? this.formatCurrency(d.hvc_min_amount, roundCount) : 0,
                    hvcMaxAmount: (d.hvc_max_amount) ? this.formatCurrency(d.hvc_max_amount, roundCount) : 0,
                };
            });
            
            const sortedAreaData = sortBy(areaData, [function(o) { return o.area; }]);

            this.areas = sortedAreaData;
        },
        fetchClinicPerformance(){
            if(this.selectedClinic.length) {
                if(!this.loadingCharts.productDosageTrends) {
                    this.fetchClinicFilterData();
                    this.fetchClinicProductDosageTrendsData();
                }
                if(!this.loadingCharts.treatmentMix) {
                    this.fetchClinicTreatmentMixData();
                }
                if(!this.loadingCharts.patientCount) {
                    this.fetchClinicPatientCountData();
                }
                if(!this.loadingCharts.patientDemographics) {
                    this.fetchClinicPatientDemographicsData();
                }
                if(!this.loadingCharts.avgAppointmentData) {
                    this.fetchClinicAvgAppointmentsPerDayData();
                }
                if(!this.loadingCharts.avgTreatmentsPerAppointment) {
                    this.fetchClinicAvgTreatmentsPerAppointmentData();
                }
            }            
        },
    },
    watch: {
        selectedNurse: {
            handler() {
                this.fetchClinicPerformance();
            },
            immediate: true,
        },
        selectedClinic: {
            handler() {
                this.fetchClinicPerformance();
            },
            immediate: true,
        },
        selectedDate: {
            handler(newVal) {
                if(newVal.length) {
                    this.fetchClinicPerformance();
                }
            },
            immediate: true,
        },
        selectedProduct: {
            handler(newVal) {
                if(newVal.length) {
                    this.fetchClinicProductDosageTrendsData();
                }
            },
            immediate: true,
        },
        selectedPatientTimePeriod: {
            handler() {
                if(this.selectedClinic.length) {
                    this.fetchClinicPatientDemographicsData();
                }
            },
            immediate: true,
        },
        selectedProductType: {
            handler() {
                if(this.selectedClinic.length) {
                    this.fetchClinicAvgTreatmentsPerAppointmentData();
                }
            },
            immediate: true,
        },
        selectedTreatmentTimePeriod: {
            handler() {
                if(this.selectedClinic.length) {
                    this.fetchClinicAvgTreatmentsPerAppointmentData();
                }
            },
            immediate: true,
        },
    },
};
</script>
<style>
.nurse-dashboard-middle .chart-widget {
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.grids-2 {
    /* grid-template-columns: 1fr 1fr; */
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 12px;
}
.mix-grids {
    /* grid-template-columns: 1fr 1fr 1fr; */
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 12px;
}
.mix-grids .chart-widget {
    display: block !important;
}
.nurse-dashboard-middle .insight-table-body.center-table .vs-table {
    text-align: center;
}
.nurse-dashboard-middle .insight-table-body.center-table th .vs-table-text {
    justify-content: center;
}
.nurse-dashboard-middle .divider-left {
    border-left: 1px solid #C9DED8;
}
.nurse-dashboard-middle .full-label label {
    width: 180px;
}
.nurse-dashboard-middle .total-row td span {
    border-top: 1px solid #C9DED8;    
    padding: 5px 30px;
    font-family: 'InterBold';
}

.insight-table-body .th-wrapper {
    padding: 10px 0 !important;
}
.insight-table-body .th-wrapper .vs-table-text {
    width: 100%;
    display: block;
    text-align: center;
}
.insight-table-body .td-span {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.insight-table-body .th-wrapper .col2,
.insight-table-body .td-span .col2 {
    width: 50%;
    float: left;
}
.insight-table-body .th-wrapper .col4,
.insight-table-body .td-span .col4 {
    width: 25%;
    float: left;
}
.insight-table-body .th-wrapper .subheading.col2 {
    align-items: center;
}
.insight-table-body .subheading.col2 {
    display: flex;
    justify-content: center;
}
.insight-table-body .subvalue.col2 {
    max-width: 150px;
}
.insight-table-body th .vs-table-text {
    color: #37695B;
    font-family: 'InterSemiBold';
    font-size: 12px;
}
.insight-table-body .vs-con-tbody {
    border: none;
    background: none;
}
.insight-table-body thead tr {
    background-color: rgba(132, 205, 184, 0.1);
    border-top: 1px solid #C9DED8;
}
.insight-widget-header {
    border-radius: 15px 15px 0 0;
    gap: 10px;
    bottom: 6px;
    position: relative;
}
.insight-widget-header .con-select,
.insight-widget-header .dashboard-select {
    display: flex;
    gap: 10px;
    align-items: center;
}
.insight-widget-header .vs-select--label,
.insight-widget-header .select-label {
    color: #37695B;
    font-family: 'InterSemiBold';
    font-size: 12px;
    width: 90px !important;
}

.insight-table-header {
    background-color: rgba(132, 205, 184, 0.1);
    border-radius: 15px 15px 0 0;
    padding: 10px;
    gap: 10px;
    margin-top: 10px;
}
.insight-table-header .el-select .el-input.is-focus .el-input__inner,
.insight-table-header .el-select .el-input__inner:focus,
.insight-table-header .el-select .el-input__inner:hover {
    border-color: #DCDFE6;
}
.insight-table-header .dashboard-select,
.insight-table-header .con-select {
    display: flex;
    gap: 10px;
    align-items: center;
}
.insight-table-header .vs-select--label,
.insight-table-header .select-label {
    color: #37695B;
    font-family: 'InterSemiBold';
    font-size: 12px;
}

.el-select-dropdown.popper-select .selected {
    color: #37695B;
    font-family: 'InterSemiBold';
}

.el-select-dropdown.popper-select .el-select-dropdown__item {
    font-family: 'Inter';
}

.insight-table-body th .vs-table-text {
    color: #37695B;
    font-family: 'InterSemiBold';
    font-size: 12px;
}
.insight-table-body .vs-con-tbody {
    border: none;
    background: none;
}
.insight-table-body thead tr {
    background-color: rgba(132, 205, 184, 0.1);
    border-top: 1px solid #C9DED8;
}

@media only screen and (max-width: 1068px) {
    .grids-2 {
        display: block !important;
    }
}
@media only screen and (max-width: 991px) {
    .mix-grids .chart-widget {
        min-height: auto !important;
    }
}

@media only screen and (max-width: 1068px) {
    .mix-grids {
        display: block !important;
    }
}
</style>